import ReactSelectField, {
  ReactCreatableSelectField as _ReactCreatableSelectField,
} from 'dashboard/components/FormControls/ReactSelectField/ReactSelectField';

export default ReactSelectField;

export const ReactCreatableSelectField = _ReactCreatableSelectField;
export type { ReactCreatableSelectFieldProps } from 'dashboard/components/FormControls/ReactSelectField/ReactSelectField';
